/** Consultant / solution-provider profile completeness (0–100) and tiers. */

export const ProfileCompletenessTier = {
  NonMatchable: 'non_matchable',
  TierC: 'tier_c',
  TierB: 'tier_b',
  TierA: 'tier_a',
} as const;

export type ProfileCompletenessTier =
  (typeof ProfileCompletenessTier)[keyof typeof ProfileCompletenessTier];

export const ProfileCompletenessTierValues = Object.values(ProfileCompletenessTier);

export const ProfileCompletenessCategory = {
  Identity: 'identity',
  Expertise: 'expertise',
  TrackRecord: 'trackRecord',
  Rates: 'rates',
  Verification: 'verification',
} as const;

export type ProfileCompletenessCategory =
  (typeof ProfileCompletenessCategory)[keyof typeof ProfileCompletenessCategory];

/** Points earned per category (max: identity 25, expertise 35, trackRecord 20, rates 10, verification 10). */
export interface ProfileCompletenessBreakdown {
  identity: number;
  expertise: number;
  trackRecord: number;
  rates: number;
  verification: number;
  totalPercent: number;
}

/**
 * Stable id for i18n / analytics; FE maps to `profileCompleteness.nudges.{id}`.
 */
export interface ProfileCompletenessNudge {
  id: string;
  category: ProfileCompletenessCategory;
  pointsAvailable: number;
}

export interface ProfileCompletenessDto {
  tier: ProfileCompletenessTier;
  breakdown: ProfileCompletenessBreakdown;
  nudges: ProfileCompletenessNudge[];
}

export function profileCompletenessTierFromPercent(
  totalPercent: number,
): ProfileCompletenessTier {
  if (totalPercent < 40) return ProfileCompletenessTier.NonMatchable;
  if (totalPercent < 60) return ProfileCompletenessTier.TierC;
  if (totalPercent < 80) return ProfileCompletenessTier.TierB;
  return ProfileCompletenessTier.TierA;
}
